import React from 'react';
import { Projects } from './../../elements/ProjectsElements';

const ProjectsDetail = () => (
    <Projects>
        <div className="container">
            <div className="projects">
            <div className="project">
                    <img src="helpfeed.png" alt="Zanele Phakathi's Help Feed A Home" />
                    <h3>Help Feed A <span className="effect">Home</span></h3>
                    <p>
                        We work closely to the Glorious Care Centre in
                        Braamfisher Soweto . We reachout to people who
                        may be in a position to help donate.
                    </p>
                </div>
                <div className="project">
                    <img src="kiddiesempowerment.png" alt="Zanele Phakathi's Kiddies Empowerment" />
                    <h3>Kiddies <span className="effect">Empowerment</span></h3>
                    <p>
                        With hosting pageants for children we always
                        have empowering project to do while having fun.
                        Clean up dobsonville is one of them. We go to a
                        nearby park and make sure it is as clean as new.
                    </p>
                </div>
                <div className="project">
                    <img src="pageantsdobsonville.png" alt="Zanele Phakathi Pageants Dobsonville" />
                    <h3>Pageants <span className="effect">Dobsonville</span></h3>
                    <p>
                        Pageants Dobsonville is a beauty pageant for
                        young girls ages 6 till 18 . Thee girls are from and
                        around Dobsonville.
                    </p>
                </div>
                <div className="project">
                    <img src="sowetodiamonds.png" alt="Zanele Phakathi's Soweto Diamonds" />
                    <h3>Soweto <span className="effect">Diamonds</span></h3>
                    <p>
                        Soweto Diamond is a model academy that Zanele
                        foundered in-order to help develop young and
                        upcoming models from Soweto and around.
                    </p>
                </div>
                <div className="project">
                    <img src="zanele-matric.png" alt="Zanele Phakathi" />
                    <h3>Take A Girl Child To <span className="effect">Matric Dance</span></h3>
                    <p>
                        We assist young ladies to have a beautiful night at
                        as we know that not everyone is as privileged and
                        matric dance only comes once in a lifetime. We
                        sponser everything from the dress, to heels, make
                        up anything we can help with.
                    </p>
                </div>
                <div className="project">
                    <img src="takealearnervarsity.png" alt="Zanele Phakathi With Learners" />
                    <h3>Help A Learner Apply For <span className="effect">Varsity</span></h3>
                    <p>
                        We are very passionate about education and this
                        is why we make sure that we help learners who
                        are currently in school to apply for varsity inorder
                        to futher their education.
                    </p>
                </div>
                <div className="project">
                    <img src="youthempowerment.png" alt="Zanele Phakathi With The Youth" />
                    <h3>Youth <span className="effect">Empowerment</span></h3>
                    <p>
                        Our organisation is by the youth for the youth. We
                        ensure that young people stay motivated at all
                        times by doing school tours from time, to time.
                    </p>
                </div>
                <div className="project">
                    <img src="paddrive.png" alt="Za Power House Pad Drive" />
                    <h3>Pad <span className="effect">Drive</span></h3>
                    <p>
                        Our organization is a 100% female owned, with
                        that we understand that menstruation is not a
                        choice and many girls struggle every month as
                        sanitary towels are costly so we help were we can.
                    </p>
                </div>
                <div className="project">
                    <img src="communityempowerment.png" alt="Zanele Phakathi With Her Community" />
                    <h3>Community <span className="effect">Empowerment</span></h3>
                    <p>
                        It takes a village to raise a child, Zanele is that
                        child and by the help of her elders she always glad
                        to help the community at large.
                    </p>
                </div>
            </div>
        </div>
    </Projects>
)

export default ProjectsDetail;